import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.bg = this.el.querySelector('.o-menu_background');
        this.container = this.el.querySelector('.o-menu_container');

        document.querySelectorAll('.menuButton').forEach(elt => {
            elt.addEventListener('click', () => {
                this.open();
            });
        });

        this.events = {
            click: {
                close: 'closeEvt',
                openContact: 'openContact',
                closeAndScroll: 'closeAndScroll',
            }
        }
    }

    open(){
        this.call('stop', 'Scroll');
        this.call('play', null, 'Logo', 'menu');
        this.el.classList.add('-visible');
        gsap.fromTo(
            this.bg,
            { autoAlpha: 0 },
            { autoAlpha: 1, duration: 0.2, ease: "none" }
        );
        gsap.fromTo(
            this.container,
            { y: '-100vh', rotate: -15 },
            { y: '0', rotate: 0, duration: 1, ease: "power4.out" }
        );
    }

    closeEvt() {
        this.close();
    }

    close(onlyClose = true){
        if (onlyClose == true) {
            this.call('start', 'Scroll');
        }
        gsap.to(this.bg, { autoAlpha: 0, duration: 0.2, ease: "none" });
        gsap.to(this.container, { y: '-120vh', rotate: -15, duration: 1, ease: "power4.out", onComplete: () => {
            this.el.classList.remove('-visible');
            this.call('pause', null, 'Logo', 'menu');
        } });
    }

    openContact(e) {
        e.preventDefault();
        
        this.close(false);
        this.call('open', 'Contact')
    }

    closeAndScroll(e) {
        e.preventDefault();
        console.log(e.currentTarget);
        
        this.close();
        setTimeout(() => {
            this.call('scrollTo', e.currentTarget.getAttribute('data-scrollto'), 'Scroll')
        }, 100);
    }
}
